import { AlertModal } from '@src/provider/AlertProvider';
import {
  selectUsers,
  setIsOpenAccountSettings,
} from '@store/slices/users/usersSlice';
import { LogOutIcon } from '@src/svg';
import React, { FC } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { handleImgError } from '@src/utils';
import { FALLBACK_IMAGE, IMAGE_STORAGE_URL } from '@src/utils/constants';
import { useLogout } from '@hooks/useLogout';
import { StatusWrapper } from '@component/StatusWrapper/StatusWrapper';

export const UserConfigDropdown: FC = () => {
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(selectUsers);
  const image = userInfo?.userInfo?.image;
  const { logoutSystem } = useLogout();

  return (
    <div
      data-test-id="c-user-config-dropdown"
      className="user_configuration__block"
    >
      <div
        className="user_configuration__block-avatar"
        data-test-id="c-user-config-dropdown-avatar"
      >
        <StatusWrapper size={10} statusColor={userInfo?.userInfo?.status}>
          <div
            className="image_wrapper"
            data-test-id="c-user-config-dropdown-image-wrapper"
          >
            <img
              alt="user info image"
              src={image ? `${IMAGE_STORAGE_URL}/${image}` : FALLBACK_IMAGE}
              onError={handleImgError}
            />
          </div>
        </StatusWrapper>
        <div>
          <div className="user_type">{userInfo?.userInfo?.type?.label}</div>
          <div className="user_mail">{userInfo?.userInfo?.email}</div>
        </div>
      </div>
      <div
        className="user_configuration__item"
        data-test-id="c-user-config-dropdown-account-settings"
        onClick={() => dispatch(setIsOpenAccountSettings(true))}
      >
        Account Settings
      </div>{' '}
      <div
        className="user_configuration__item"
        data-test-id="c-user-config-dropdown-logout"
        onClick={() => {
          AlertModal.show({
            title: 'Are you sure you want to logout?',
            message:
              'Logging out may discard unsaved data. Please take a moment to save your work if needed. Do you want to continue?',
            buttons: [
              {
                title: 'Cancel',
                color: '#C6470FFF',
                onClick: () => {},
              },
              {
                title: 'Continue',
                color: '#4F7EFFFF',
                onClick: logoutSystem,
              },
            ],
          });
        }}
      >
        <LogOutIcon color="#FFFFFFB3" width={16} height={16} />
        <h4>Logout</h4>
      </div>
    </div>
  );
};
